import { Head, CleanContent } from './ui';

export default function Integrity() {
  return (
    <CleanContent><section className="bg-navy py-5">
        <div className="container">
          <Head light eyebrow="Integrity Framework"  title="Recognition Should Be Earned"
            text="Your business should earn market recognition because users genuinely value its execution. SELECTEZI rejects pay to win business directories. Advertising can increase top of funnel reach, but your Star Rank is governed exclusively by proven operational caliber, authenticated evaluations, and consistent performance." />
          <div className="row g-3 mb-4">
            <div className="col-md-6">
              <div className="rounded-3 p-4 h-100" style={{ background: "rgba(255,255,255,.1)" }}>
                <div className="eyebrow light mb-2">Channel Dynamics</div>
                <div className="h-md mb-2">Paid Visibility</div>
                <p className="p-sm mb-3">Broad commercial broadcast, sponsored placement banners, targeted impressions, and reach amplification, vital for immediate exposure but grants zero star weighting</p>
                <span className="badge bg-light text-dark">Role: Exposure & Acquisition</span>
              </div>
            </div>
            <div className="col-md-6">
              <div className="rounded-3 p-4 h-100 bg-white text-dark">
                <div className="eyebrow mb-2">Accreditation Engine</div>
                <div className="h-md mb-2">Earned Reputation</div>
                <p className="p-sm mb-3">Authenticated buyer audits, fast dispute resolution, confirmed deliveries, and organic community support, the single immutable foundation of your SELECTEZI Star Rank</p>
                <span className="badge bg-primary">Role: Star Rank Determination</span>
              </div>
            </div>
          </div>
          <div className="text-center">
            <div className="d-inline-block bg-white text-dark rounded-3 px-4 py-3 fw-semibold">
              Advertising can increase visibility<br />Your Star Rank is earned
            </div>
          </div>
        </div>
      </section></CleanContent>
  );
}
